module.exports = __webpack_public_path__ + "media/images/v2/live_event_image-814fb25b09c892de331cd5c8c49bde61.png";